/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertScheduleOfValuesPayloadDto
 */
export interface UpsertScheduleOfValuesPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    sovId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    severity?: UpsertScheduleOfValuesPayloadDtoSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    submissionId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    fileId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    property?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    streetAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    suburb?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    postalZipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    crestaZone?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    occupancy?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    buildingValue?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    cpe?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    stock?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    pdValue?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    biRate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    pdRate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    pdDeductibles?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    biValue?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    latitude?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    longitude?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    constructionClass?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    roofType?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    numberOfStories?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    yearBuilt?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    fluvialFlood?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    originalStormSurge?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    originalPfRiskLevel?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    windstorm?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    hailstorm?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    wildfire?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    locationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertScheduleOfValuesPayloadDto
     */
    totalInsurableValue: string;
}


/**
 * @export
 */
export const UpsertScheduleOfValuesPayloadDtoSeverityEnum = {
    Low: 'Low',
    Average: 'Average',
    High: 'High'
} as const;
export type UpsertScheduleOfValuesPayloadDtoSeverityEnum = typeof UpsertScheduleOfValuesPayloadDtoSeverityEnum[keyof typeof UpsertScheduleOfValuesPayloadDtoSeverityEnum];


/**
 * Check if a given object implements the UpsertScheduleOfValuesPayloadDto interface.
 */
export function instanceOfUpsertScheduleOfValuesPayloadDto(value: object): value is UpsertScheduleOfValuesPayloadDto {
    if (!('totalInsurableValue' in value) || value['totalInsurableValue'] === undefined) return false;
    return true;
}

export function UpsertScheduleOfValuesPayloadDtoFromJSON(json: any): UpsertScheduleOfValuesPayloadDto {
    return UpsertScheduleOfValuesPayloadDtoFromJSONTyped(json, false);
}

export function UpsertScheduleOfValuesPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertScheduleOfValuesPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sovId': json['sovId'] == null ? undefined : json['sovId'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'submissionId': json['submissionId'] == null ? undefined : json['submissionId'],
        'fileId': json['fileId'] == null ? undefined : json['fileId'],
        'property': json['property'] == null ? undefined : json['property'],
        'streetAddress': json['streetAddress'] == null ? undefined : json['streetAddress'],
        'suburb': json['suburb'] == null ? undefined : json['suburb'],
        'state': json['state'] == null ? undefined : json['state'],
        'postalZipCode': json['postalZipCode'] == null ? undefined : json['postalZipCode'],
        'crestaZone': json['crestaZone'] == null ? undefined : json['crestaZone'],
        'country': json['country'] == null ? undefined : json['country'],
        'occupancy': json['occupancy'] == null ? undefined : json['occupancy'],
        'buildingValue': json['buildingValue'] == null ? undefined : json['buildingValue'],
        'cpe': json['cpe'] == null ? undefined : json['cpe'],
        'stock': json['stock'] == null ? undefined : json['stock'],
        'pdValue': json['pdValue'] == null ? undefined : json['pdValue'],
        'biRate': json['biRate'] == null ? undefined : json['biRate'],
        'pdRate': json['pdRate'] == null ? undefined : json['pdRate'],
        'pdDeductibles': json['pdDeductibles'] == null ? undefined : json['pdDeductibles'],
        'biValue': json['biValue'] == null ? undefined : json['biValue'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'constructionClass': json['constructionClass'] == null ? undefined : json['constructionClass'],
        'roofType': json['roofType'] == null ? undefined : json['roofType'],
        'numberOfStories': json['numberOfStories'] == null ? undefined : json['numberOfStories'],
        'yearBuilt': json['yearBuilt'] == null ? undefined : json['yearBuilt'],
        'fluvialFlood': json['fluvialFlood'] == null ? undefined : json['fluvialFlood'],
        'originalStormSurge': json['originalStormSurge'] == null ? undefined : json['originalStormSurge'],
        'originalPfRiskLevel': json['originalPfRiskLevel'] == null ? undefined : json['originalPfRiskLevel'],
        'windstorm': json['windstorm'] == null ? undefined : json['windstorm'],
        'hailstorm': json['hailstorm'] == null ? undefined : json['hailstorm'],
        'wildfire': json['wildfire'] == null ? undefined : json['wildfire'],
        'locationNumber': json['locationNumber'] == null ? undefined : json['locationNumber'],
        'totalInsurableValue': json['totalInsurableValue'],
    };
}

export function UpsertScheduleOfValuesPayloadDtoToJSON(json: any): UpsertScheduleOfValuesPayloadDto {
    return UpsertScheduleOfValuesPayloadDtoToJSONTyped(json, false);
}

export function UpsertScheduleOfValuesPayloadDtoToJSONTyped(value?: UpsertScheduleOfValuesPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sovId': value['sovId'],
        'severity': value['severity'],
        'submissionId': value['submissionId'],
        'fileId': value['fileId'],
        'property': value['property'],
        'streetAddress': value['streetAddress'],
        'suburb': value['suburb'],
        'state': value['state'],
        'postalZipCode': value['postalZipCode'],
        'crestaZone': value['crestaZone'],
        'country': value['country'],
        'occupancy': value['occupancy'],
        'buildingValue': value['buildingValue'],
        'cpe': value['cpe'],
        'stock': value['stock'],
        'pdValue': value['pdValue'],
        'biRate': value['biRate'],
        'pdRate': value['pdRate'],
        'pdDeductibles': value['pdDeductibles'],
        'biValue': value['biValue'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'constructionClass': value['constructionClass'],
        'roofType': value['roofType'],
        'numberOfStories': value['numberOfStories'],
        'yearBuilt': value['yearBuilt'],
        'fluvialFlood': value['fluvialFlood'],
        'originalStormSurge': value['originalStormSurge'],
        'originalPfRiskLevel': value['originalPfRiskLevel'],
        'windstorm': value['windstorm'],
        'hailstorm': value['hailstorm'],
        'wildfire': value['wildfire'],
        'locationNumber': value['locationNumber'],
        'totalInsurableValue': value['totalInsurableValue'],
    };
}

